export const headerKey = 'Authorization';
export const encodeHeader = (value, type) => type && value.trim().replace(':', '')
    ? {
        [headerKey]: type === 'basic' ? `Basic ${window.btoa(value)}` : `Bearer ${value}`,
    }
    : {};
export const getHeaderType = (header) => {
    const value = header[headerKey];
    if (!(value === null || value === void 0 ? void 0 : value.startsWith('Basic ')) && !(value === null || value === void 0 ? void 0 : value.startsWith('Bearer '))) {
        return null;
    }
    const [format] = value.split(' ');
    return format === 'Bearer' ? 'token' : 'basic';
};
export const authorizationItems = [
    { id: 'basic', name: 'Basic Auth' },
    { id: 'token', name: 'Token' },
];
